/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { KTIcon, toAbsoluteUrl } from '../../../../_metronic/helpers';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import request from '../../../../utils/request';
import { IdentifyType } from "../../../../constants";
import { RootState } from "../../../../global/store";
import moment from "moment/moment";
// import { updateProcessMonitoringDashboard } from '../../../../global/features/dashboardSlice';

type Props = {
	className: string;
	statusColor?: string;
};

const Monitoring: React.FC<Props> = ({ className, statusColor = '' }) => {
	// const [nullPage, setnullPage] = useState(false)
	const identify: IdentifyType = useSelector(
		(v: RootState) => v.customerReducer.identify
	);

	let custNum = localStorage.getItem('customerNum');
	useEffect(() => {
		if (identify?.area_code !== null && identify?.area_code !== '') {
			getProcessMonitoringList();
		}
		// refreshChart()

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [identify?.area_code]);

	const dispatch = useDispatch();

	const [loading, setLoading] = useState(true);

	const [processMon, setProcessMon] = useState<any>([]);


	// const processMonitoringDashboard: any = useSelector(
	// 	(val: RootState) => val.dashboardReducer.processMonitoringDashboard
	// );

	const getProcessMonitoringList = async () => {
		let payload: any = {
			draw: 0,
			start: '0',
			length: 5,
			search: {
				value: custNum || '',
				regex: true,
			},
			advSearch: {
				areaCode: identify?.area_code,
				notifikasiLastSeen: JSON.stringify(identify?.notifikasiLastSeen)
				// notifikasiLastSeen: moment(identify?.notifikasiLastSeen).utcOffset(0).format('YYYY-MM-DD HH:mm:ss')
			}
		};

		// await request.post('/subscription/listamandemen', payload).then((v) => {
		// 	const vdata = v?.data?.data;
		// 	if (vdata) {
		// 		dispatch(
		// 			updateProcessMonitoringDashboard(
		// 				vdata.map((v) => {
		// 					const nv = {
		// 						status: v.docStatus,
		// 						productName: v.namaPerusahaan,
		// 						type: 'Amandemen Baru',
		// 						link: '/amendment/1',
		// 					};
		// 					return nv;
		// 				})
		// 			)
		// 		);
		// 		// dispatch(addAmandemenList(v.data))
		// 	}
		// });

		await request
			.post('/dashboard/GetProcessMonitoringDashboard', payload)
			.then((v) => {
				const vdata = v?.data?.data;
				if (vdata) {
					const serviceRequests = vdata['serviceRequest'] || [];
					const amendments = vdata['amendment'] || [];

					const pmList = [
						...amendments.map((item: any) => {
							return {
								title: item.docNumber,
								subTitle: 'Amendment',
								status: item.docStatus,
								link: '/amendment/1',
							};
						}),
						...serviceRequests.map((item: any) => {
							return {
								title: item.submission_number,
								subTitle: 'Service Request', //item.product_name,
								status: item.status,
								link: '/customer-support/1',
							};
						}),
					];
					setProcessMon(pmList);
				}
			});

		setLoading(false);
	};

	return (
		<div className={`card ${className}`}>
			<div style={{ height: '100px' }} className="card-header border-2">
				<h3 className="card-title align-items-start flex-column">
					<span className="card-label fw-bold fs-3 mb-3">
						Process monitoring
					</span>
					<span className="text-muted mt-1 fw-bold fs-7">
						Amendments and service request
					</span>
				</h3>
			</div>
			<div
				style={{ overflow: 'scroll', height: '375px' }}
				className="card-body py-3"
			>
				{!processMon || processMon?.length === 0 ? (
					loading ? (
						<span
							className="indicator-progress text-center"
							style={{ display: 'block' }}
						>
							Please wait...{' '}
							<span className="spinner-border spinner-border-sm align-middle"></span>
						</span>
					) : (
						<div className="d-flex justify-content-center mt-8 flex-wrap">
							<img
								className="w-50"
								style={{ objectFit: 'scale-down' }}
								src={toAbsoluteUrl(
									'/media/pgn/Empty state.png'
								)}
								alt=""
							/>
							{/* <div className='w-100 text-center fs-5 fw-semibold'>No data found.</div> */}
						</div>
					)
				) : (
					<div className="table-responsive">
						<table className="table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4">
							<thead>
								<tr className="border-0">
									<th className="p-0 min-w-175px"></th>
									<th className="p-0 w-175px"></th>
									<th className="p-0 w-100px"></th>
									<th className="p-0 w-25px"></th>
								</tr>
							</thead>
							<tbody>
								{processMon.map((v, i) => {
									return (
										<tr className="align-middle" key={i}>
											<td>
												<Link to={v.link}>
													<div className="text-dark fw-bold text-hover-primary mb-1 fs-6">
														{v.title}
													</div>
													<span className="text-muted fw-semibold d-block">
														{v.subTitle}
													</span>
												</Link>
											</td>
											<td className="fw-semibold text-end"></td>
											<td className="text-end">
												<span
													className={`badge w-75px d-flex justify-content-center ${v.status ===
															'Approved' ||
															v.status === 'Completed'
															? 'badge-light-success'
															: v.status ==
																'Rejected'
																? 'badge-light-danger'
																: 'badge-light-warning'
														}`}
												>
													{v.status}
												</span>
											</td>
											<td className="text-end">
												<Link
													to={v.link}
													className="btn btn-sm btn-icon btn-bg-light btn-active-color-primary"
												>
													<KTIcon
														iconName="arrow-right"
														className="fs-2"
													/>
												</Link>
											</td>
										</tr>
									);
								})}
							</tbody>
						</table>
					</div>
				)}
			</div>
		</div>
	);
};

export { Monitoring };
